/** Navigation only; readiness remains the authority for business state. */
export const PREPARATION_SECTIONS = [
  "authorization",
  "specification",
  "census",
  "insurers",
  "review",
] as const;
export function preparationSection(value: string | null | undefined) {
  return PREPARATION_SECTIONS.find((section) => section === value);
}
export function preparationHref(requestId: string, section?: string | null) {
  const selected = preparationSection(section);
  return `/quote-requests/${encodeURIComponent(requestId)}/preparer${selected ? `?section=${selected}` : ""}`;
}
export function censusPreparationHref(projectId: string, requestId: string) {
  const params = new URLSearchParams({
    view: "preparation",
    request: requestId,
    request_section: "specification",
  });
  return `/projects/${encodeURIComponent(projectId)}?${params}#census`;
}
